//src/components/ContactInformation.jsx
import React from 'react';
import { IconButton, Box, Typography, Link } from '@mui/material';
import { Email, LocationOn, Facebook, Instagram } from '@mui/icons-material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import YouTubeIcon from '@mui/icons-material/YouTube';

const brandColors = {
  facebook: '#1877F2',
  youtube: '#FF0000',
  instagram: '#E4405F',
  whatsapp: '#25D366',
};

const ContactInformation = () => {
  return (
    <Box sx={{ px: 1 }}>
      {/* Header */}
      <Typography variant="h6" sx={{ fontSize: { xs: '1.1rem', sm: '1.25rem' } }}>
        Get in Touch
      </Typography>

      {/* Email */}
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.5, mt: 1 }}>
        <IconButton size="small" sx={{ p: 0.5 }}>
          <Email sx={{ fontSize: { xs: 20, sm: 24 } }} />
        </IconButton>
        <Box>
          <Typography variant="body2" sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}>
            Email:
          </Typography>
          <Link
            href="mailto:support@noorunnikah.com"
            underline="none"
            sx={{
              fontSize: { xs: '0.875rem', sm: '1rem' },
              wordBreak: 'break-all'
            }}
          >
            support@noorrunikah.com
          </Link>
        </Box>
      </Box>

      {/* WhatsApp */}
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.5, mt: 1 }}>
        <IconButton size="small" sx={{ p: 0.5 }}>
          <WhatsAppIcon sx={{ fontSize: { xs: 20, sm: 24 } }} />
        </IconButton>
        <Box>
          <Typography variant="body2" sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}>
            WhatsApp:
          </Typography>
          <Link
            href="https://wa.me/923425262121"
            target="_blank"
            rel="noopener noreferrer"
            underline="none"
            sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}
          >
            +92 34 2526 2121
          </Link>
        </Box>
      </Box>

      {/* Address */}
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.5, mt: 1 }}>
        <IconButton size="small" sx={{ p: 0.5 }}>
          <LocationOn sx={{ fontSize: { xs: 20, sm: 24 } }} />
        </IconButton>
        <Box>
          <Typography variant="body2" sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}>
            Address:
          </Typography>
          <Link
            href="#"
            underline="none"
            sx={{
              fontSize: { xs: '0.875rem', sm: '1rem' },
              color: 'inherit',
              cursor: 'default'
            }}
          >
            ShadBagh, Lahore, Pakistan
          </Link>
        </Box>
      </Box>

      {/* Social Media */}
      <Typography
        variant="h6"
        gutterBottom
        sx={{
          mt: 3,
          fontSize: { xs: '1.1rem', sm: '1.25rem' },
          textAlign: 'left'
        }}
      >
        Follow Us
      </Typography>
      <Box
        sx={{
          display: 'flex',
          gap: { xs: 1, sm: 3 },
          justifyContent: 'flex-start',
          mb: 2,
          flexWrap: 'wrap',
        }}
      >
        <IconButton
          href="https://www.facebook.com/NoorUnNikah"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Facebook"
          sx={{
            color: brandColors.facebook,
            p: { xs: 0.5, sm: 1 }
          }}
          size="small"
        >
          <Facebook sx={{ fontSize: { xs: 28, sm: 36 } }} />
        </IconButton>

        <IconButton
          href="https://www.youtube.com/@TerViTusOrg"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="YouTube"
          sx={{
            color: brandColors.youtube,
            p: { xs: 0.5, sm: 1 }
          }}
          size="small"
        >
          <YouTubeIcon sx={{ fontSize: { xs: 28, sm: 36 } }} />
        </IconButton>

        <IconButton
          href="https://www.instagram.com/TervitusOrg/#"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Instagram"
          sx={{
            color: brandColors.instagram,
            p: { xs: 0.5, sm: 1 }
          }}
          size="small"
        >
          <Instagram sx={{ fontSize: { xs: 28, sm: 36 } }} />
        </IconButton>

        <IconButton
          href="https://whatsapp.com/channel/0029Vb5jX1O3QxRuxbhhqI2Q"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="WhatsApp"
          sx={{
            color: brandColors.whatsapp,
            p: { xs: 0.5, sm: 1 }
          }}
          size="small"
        >
          <WhatsAppIcon sx={{ fontSize: { xs: 28, sm: 36 } }} />
        </IconButton>
      </Box>
    </Box>
  );
};

export default ContactInformation;